import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { map } from 'rxjs/operators/map';

@Injectable()
export class MenuService {

  private files: any[] = [{
    text: 'Home', cssClass: 'blue', path: '', iconClass: 'k-i-globe'
  },
    {
      text: 'Advanced Search', cssClass: 'blue', iconClass: 'k-i-page-properties', path: '/advancedSearch'
    }
  ];

  constructor(private http: HttpClient) { }

  public getFiles() {
    return this.files;
  }


}
